export default (direction) => {
  const body = document.body;
  const scrollDown = 'scroll-down';

  if (direction === 'down' && !body.classList.contains(scrollDown)) {
    body.classList.add(scrollDown);
  } else if (direction === 'up' && body.classList.contains(scrollDown)) {
    body.classList.remove(scrollDown);
  }
};
